module.exports = __webpack_public_path__ + "static/media/real estate.9a020434.jpg";